import { useState } from 'react';

import type { Filter } from '../../../types/SortAndFilter';

export const useFilterSearch = (filters: Filter[]) => {
  const [searchValues, setSearchValues] = useState<Record<string, string>>({});
  const [filteredOptions, setFilteredOptions] = useState<Record<string, any[]>>({});

  const onSearchValueChange = (filterKey: string, value: string) => {
    setSearchValues(prev => ({
      ...prev,
      [filterKey]: value,
    }));

    const filter = filters.find(f => f.key === filterKey);
    if (filter && 'options' in filter) {
      const newFilteredOptions = value
        ? filter.options.filter(option => option.value.toLowerCase().includes(value.toLowerCase()))
        : filter.options;

      setFilteredOptions(prev => ({
        ...prev,
        [filterKey]: newFilteredOptions,
      }));
    }
  };

  return { searchValues, filteredOptions, onSearchValueChange };
};
